import FetchClients, { ClientOutput } from "../client";
import {
  useMutation,
  useQuery as useReactQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { useCurrentUser } from "@src/context/UserContext";

export type NotificationUserPreferences =
  ClientOutput["notification"]["UserPreferences"];

const userPreferences = {
  useQuery,
  mutations: {
    usePostUtilityBillSummaryPreference,
  },
} as const;

export default userPreferences;

const USER_PREFERENCES_KEY = "notification-user-preferences";
function useQuery() {
  const { id } = useCurrentUser();

  return useReactQuery<NotificationUserPreferences>({
    queryKey: [USER_PREFERENCES_KEY, id],

    queryFn: async () => {
      const { data, error } = await FetchClients.notification.GET(
        "/user/preferences"
      );
      if (data) return data;
      throw new Error(error);
    },
  });
}

function usePostUtilityBillSummaryPreference() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: { enabled: boolean }) => {
      const { data, error } = await FetchClients.notification.POST(
        "/user/utility_bill_summary_preference",
        {
          body,
        }
      );
      if (data) return data;
      throw new Error(error);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [USER_PREFERENCES_KEY],
      });
    },
  });
}
